// This file is auto-generated. Do not edit!

export default [
  {
    address: "0x160dE4468586B6B2F8a92FEB0c260Fc6cFC743B1",
    symbol: "ease.org",
  },
  {
    address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
    symbol: "WETH",
  },
  {
    address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
    symbol: "WBTC",
  },
  {
    address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
    symbol: "USDC",
  },
  {
    address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
    symbol: "USDT",
  },
  {
    address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
    symbol: "DAI",
  },
  {
    address: "0xbbAec992fc2d637151dAF40451f160bF85f3C8C1",
    symbol: "USDM",
  },
  {
    address: "0x6982508145454Ce325dDbE47a25d4ec3d2311933",
    symbol: "PEPE",
  },
  {
    address: "0x514910771AF9Ca656af840dff83E8264EcF986CA",
    symbol: "LINK",
  },
  {
    address: "0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984",
    symbol: "UNI",
  },
  {
    address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
    symbol: "cbBTC",
  },
  {
    address: "0x7Fc66500c84A76Ad7e9c93437bFc5Ac33E2DDaE9",
    symbol: "AAVE",
  },
  {
    address: "0x5F0E628B693018f639D10e4A4F59BD4d8B2B6B44",
    symbol: "WHITE",
  },
  {
    address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
    symbol: "wstETH",
  },
  {
    address: "0xdA5e1988097297dCdc1f90D4dFE7909e847CBeF6",
    symbol: "WLFI",
  },
  {
    address: "0xf80FC1ce16cBCBD18421E9Cd055CA1Bb58A9E097",
    symbol: "ETHM",
  },
  {
    address: "0xFa2B947eEc368f42195f24F36d2aF29f7c24CeC2",
    symbol: "USDf",
  },
  {
    address: "0x64aa3364F17a4D01c6f1751Fd97C2BD3D7e7f1D5",
    symbol: "OHM",
  },
  {
    address: "0xE0f63A424a4439cBE457D80E4f4b51aD25b2c56C",
    symbol: "SPX",
  },
  {
    address: "0x77E06c9eCCf2E797fd462A92B6D7642EF85b0A44",
    symbol: "wTAO",
  },
  {
    address: "0x6f40d4A6237C257fff2dB00FA0510DeEECd303eb",
    symbol: "INST",
  },
  {
    address: "0x8236a87084f8B84306f72007F36F2618A5634494",
    symbol: "LBTC",
  },
  {
    address: "0x95aD61b0a150d79219dCF64E1E6Cc01f0B64C4cE",
    symbol: "SHIB",
  },
  {
    address: "0x7A56E1C57C7475CCf742a1832B028F0456652F97",
    symbol: "SolvBTC",
  },
  {
    address: "0xD31a59c85aE9D8edEFeC411D448f90841571b89c",
    symbol: "SOL",
  },
  {
    address: "0xec53bF9167f50cDEB3Ae105f56099aaaB9061F83",
    symbol: "EIGEN",
  },
  {
    address: "0xA35923162C49cF95e6BF26623385eb431ad920D3",
    symbol: "TURBO",
  },
  {
    address: "0x8d0D000Ee44948FC98c9B98A4FA4921476f08B0d",
    symbol: "USD1",
  },
  {
    address: "0x437cc33344a0B27A429f795ff6B469C72698B291",
    symbol: "wM",
  },
  {
    address: "0x853d955aCEf822Db058eb8505911ED77F175b99e",
    symbol: "FRAX",
  },
  {
    address: "0x5A98FcBEA516Cf06857215779Fd812CA3beF1B32",
    symbol: "LDO",
  },
  {
    address: "0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2",
    symbol: "MKR",
  },
  {
    address: "0x57e114B691Db790C35207b2e685D4A43181e6061",
    symbol: "ENA",
  },
  {
    address: "0x761D38e5ddf6ccf6Cf7c55759d5210750B5D60F3",
    symbol: "ELON",
  },
  {
    address: "0xfAbA6f8e4a5E8Ab82F62fe7C39859FA577269BE3",
    symbol: "ONDO",
  },
  {
    address: "0x68749665FF8D2d112Fa859AA293F07A622782F38",
    symbol: "XAUt",
  },
  {
    address: "0xD533a949740bb3306d119CC777fa900bA034cd52",
    symbol: "CRV",
  },
  {
    address: "0x927402ab67c0CDA3c187E9DFE34554AC581441f2",
    symbol: "SAITABIT",
  },
  {
    address: "0x44ff8620b8cA30902395A7bD3F2407e1A091BF73",
    symbol: "VIRTUAL",
  },
  {
    address: "0xbdF43ecAdC5ceF51B7D1772F722E40596BC1788B",
    symbol: "SEI",
  },
  {
    address: "0xC18360217D8F7Ab5e7c516566761Ea12Ce7F9D72",
    symbol: "ENS",
  },
  {
    address: "0x45804880De22913dAFE09f4980848ECE6EcbAf78",
    symbol: "PAXG",
  },
  {
    address: "0xf9902EdfCa4F49DcaEBC335C73aEbD82C79C2886",
    symbol: "ADO",
  },
  {
    address: "0xd5F7838F5C461fefF7FE49ea5ebaF7728bB0ADfa",
    symbol: "mETH",
  },
  {
    address: "0x3c3a81e81dc49A522A592e7622A7E711c06bf354",
    symbol: "MNT",
  },
  {
    address: "0x8881562783028F5c1BCB985d2283D5E170D88888",
    symbol: "SHFL",
  },
  {
    address: "0xe76C6c83af64e4C60245D8C7dE953DF673a7A33D",
    symbol: "RAIL",
  },
  {
    address: "0xc00e94Cb662C3520282E6f5717214004A7f26888",
    symbol: "COMP",
  },
  {
    address: "0x3472A5A71965499acd81997a54BBA8D852C6E53d",
    symbol: "BADGER",
  },
  {
    address: "0x956F47F50A910163D8BF957Cf5846D573E7f87CA",
    symbol: "FEI",
  },
  {
    address: "0x72e4f9F808C49A2a61dE9C5896298920Dc4EEEa9",
    symbol: "BITCOIN",
  },
  {
    address: "0x046EeE2cc3188071C02BfC1745A6b17c656e3f3d",
    symbol: "RLB",
  },
  {
    address: "0x163f8C2467924be0ae7B5347228CABF260318753",
    symbol: "WLD",
  },
  {
    address: "0x4c9EDD5852cd905f086C759E8383e09bff1E68B3",
    symbol: "USDe",
  },
  {
    address: "0xf34960d9d60be18cC1D5Afc1A6F012A723a28811",
    symbol: "KCS",
  },
  {
    address: "0x57B96D4aF698605563A4653D882635da59Bf11AF",
    symbol: "RCH",
  },
  {
    address: "0xBAac2B4491727D78D2b78815144570b9f2Fe8899",
    symbol: "DOG",
  },
  {
    address: "0xb788144DF611029C60b859DF47e79B7726C4DEBa",
    symbol: "VULT",
  },
  {
    address: "0x45e02bc2875A2914C4f585bBF92a6F28bc07CB70",
    symbol: "$MBG",
  },
  {
    address: "0x6De037ef9aD2725EB40118Bb1702EBb27e4Aeb24",
    symbol: "RNDR",
  },
  {
    address: "0x0d438F3b5175Bebc262bF23753C1E53d03432bDE",
    symbol: "wNXM",
  },
  {
    address: "0xE99620545740a30Dbf8B4601d2F7dDC99cC1dc42",
    symbol: "NO",
  },
  {
    address: "0xaea46A60368A7bD060eec7DF8CBa43b7EF41Ad85",
    symbol: "FET",
  },
  {
    address: "0x52A8845DF664D76C69d2EEa607CD793565aF42B8",
    symbol: "APEX",
  },
  {
    address: "0xC011a73ee8576Fb46F5E1c5751cA3B9Fe0af2a6F",
    symbol: "SNX",
  },
  {
    address: "0x111111111117dC0aa78b770fA6A738034120C302",
    symbol: "1INCH",
  },
  {
    address: "0xbC396689893D065F41bc2C6EcbeE5e0085233447",
    symbol: "PERP",
  },
  {
    address: "0x643C4E15d7d62Ad0aBeC4a9BD4b001aA3Ef52d66",
    symbol: "SYRUP",
  },
  {
    address: "0x582d872A1B094FC48F5DE31D3B73F2D9bE47def1",
    symbol: "TONCOIN",
  },
  {
    address: "0x57Ab1ec28D129707052df4dF418D58a2D46d5f51",
    symbol: "sUSD",
  },
  {
    address: "0xA0335820dC549dBfae5b8D691331CadfCA7026E0",
    symbol: "SHIBA2",
  },
  {
    address: "0x0000000000c5dc95539589fbD24BE07c6C14eCa4",
    symbol: "CULT",
  },
  {
    address: "0x037A54AaB062628C9Bbae1FDB1583c195585fe41",
    symbol: "LCX",
  },
  {
    address: "0xaaeE1A9723aaDB7afA2810263653A34bA2C21C7a",
    symbol: "Mog",
  },
  {
    address: "0xF19308F923582A6f7c465e5CE7a9Dc1BEC6665B1",
    symbol: "TITANX",
  },
  {
    address: "0xCfa0885131F602D11D4DA248D2c65A62063567A9",
    symbol: "TORG",
  },
  {
    address: "0x9AAb071B4129B083B01cB5A0Cb513Ce7ecA26fa5",
    symbol: "HUNT",
  },
  {
    address: "0xd0D56273290D339aaF1417D9bfa1bb8cFe8A0933",
    symbol: "FOOM",
  },
  {
    address: "0xBe9895146f7AF43049ca1c1AE358B0541Ea49704",
    symbol: "cbETH",
  },
  {
    address: "0xdd3B11eF34cd511a2DA159034a05fcb94D806686",
    symbol: "REKT",
  },
  {
    address: "0x5F7827FDeb7c20b443265Fc2F40845B715385Ff2",
    symbol: "EURCV",
  },
  {
    address: "0x58D97B57BB95320F9a05dC918Aef65434969c2B2",
    symbol: "MORPHO",
  },
  {
    address: "0xdA67B4284609d2d48e5d10cfAc411572727dc1eD",
    symbol: "USN",
  },
  {
    address: "0x9E9FbDE7C7a83c43913BddC8779158F1368F0413",
    symbol: "PANDORA",
  },
  {
    address: "0x77777FeDdddFfC19Ff86DB637967013e6C6A116C",
    symbol: "TORN",
  },
  {
    address: "0xf65B5C5104c4faFD4b709d9D60a185eAE063276c",
    symbol: "TRU",
  },
  {
    address: "0x5422374B27757da72d5265cC745ea906E0446634",
    symbol: "USDCV",
  },
  {
    address: "0x4a220E6096B25EADb88358cb44068A3248254675",
    symbol: "QNT",
  },
  {
    address: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c",
    symbol: "EUROC",
  },
  {
    address: "0xADe6FDAba1643E4D1eeF68Da7170F234470938c6",
    symbol: "HARAMBE",
  },
  {
    address: "0x0ab87046fBb341D058F17CBC4c1133F25a20a52f",
    symbol: "gOHM",
  },
  {
    address: "0xDEf1CA1fb7FBcDC777520aa7f396b4E015F497aB",
    symbol: "COW",
  },
  {
    address: "0xB62132e35a6c13ee1EE0f84dC5d40bad8d815206",
    symbol: "NEXO",
  },
  {
    address: "0x18084fbA666a33d37592fA2633fD49a74DD93a88",
    symbol: "tBTC",
  },
  {
    address: "0x6619078Bdd8324E01E9a8D4b3d761b050E5ECF06",
    symbol: "MAL",
  },
  {
    address: "0x955d5c14C8D4944dA1Ea7836bd44D54a8eC35Ba1",
    symbol: "RFD",
  },
  {
    address: "0x3d5d3DCD01469eF8C6bC9C45665835814635c725",
    symbol: "MRF",
  },
  {
    address: "0xae78736Cd615f374D3085123A210448E74Fc6393",
    symbol: "rETH",
  },
  {
    address: "0x02f92800F57BCD74066F5709F1Daa1A4302Df875",
    symbol: "PEAS",
  },
  {
    address: "0xA0b73E1Ff0B80914AB6fe0444E65848C4C34450b",
    symbol: "CRO",
  },
  {
    address: "0xE9A95d175a5f4C9369f3b74222402eB1b837693b",
    symbol: "NOW",
  },
  {
    address: "0x626E8036dEB333b408Be468F951bdB42433cBF18",
    symbol: "AIOZ",
  },
  {
    address: "0xFeAc2Eae96899709a43E252B6B92971D32F9C0F9",
    symbol: "ANYONE",
  },
  {
    address: "0x40e3d1A4B2C47d9AA61261F5606136ef73E28042",
    symbol: "SERV",
  },
  {
    address: "0x808507121B80c02388fAd14726482e061B8da827",
    symbol: "PENDLE",
  },
  {
    address: "0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee",
    symbol: "weETH",
  },
  {
    address: "0xB528edBef013aff855ac3c50b381f253aF13b997",
    symbol: "AEVO",
  },
  {
    address: "0xC581b735A1688071A1746c968e0798D642EDE491",
    symbol: "EURT",
  },
  {
    address: "0x1A4b46696b2bB4794Eb3D4c26f1c55F9170fa4C5",
    symbol: "BIT",
  },
  {
    address: "0x56072C95FAA701256059aa122697B133aDEd9279",
    symbol: "SKY",
  },
  {
    address: "0xA26Cbb76156090f4B40A1799A220fc4C946aFB3c",
    symbol: "YNG",
  },
  {
    address: "0x9D39A5DE30e57443BfF2A8307A4256c8797A3497",
    symbol: "sUSDe",
  },
  {
    address: "0x8143182a775C54578c8B7b3Ef77982498866945D",
    symbol: "wQUIL",
  },
  {
    address: "0x7D1AfA7B718fb893dB30A3aBc0Cfc608AaCfeBB0",
    symbol: "MATIC",
  },
  {
    address: "0x6DEA81C8171D0bA574754EF6F8b412F2Ed88c54D",
    symbol: "LQTY",
  },
  {
    address: "0x7A58c0Be72BE218B41C608b7Fe7C5bB630736C71",
    symbol: "PEOPLE",
  },
  {
    address: "0x812Ba41e071C7b7fA4EBcFB62dF5F45f6fA853Ee",
    symbol: "Neiro",
  },
  {
    address: "0xFe2e637202056d30016725477c5da089Ab0A043A",
    symbol: "sETH2",
  },
  {
    address: "0xb131f4A55907B10d1F0A50d8ab8FA09EC342cd74",
    symbol: "MEME",
  },
  {
    address: "0xAf5191B0De278C7286d6C7CC6ab6BB8A73bA2Cd6",
    symbol: "STG",
  },
  {
    address: "0x967351153d738Fd35D2b2F82109194a548e5cb8c",
    symbol: "REEE",
  },
  {
    address: "0xAa6E8127831c9DE45ae56bB1b0d4D4Da6e5665BD",
    symbol: "ETH2x-FLI",
  },
  {
    address: "0x50327c6c5a14DCaDE707ABad2E27eB517df87AB5",
    symbol: "TRX",
  },
  {
    address: "0xD9A442856C234a39a81a089C06451EBAa4306a72",
    symbol: "pufETH",
  },
  {
    address: "0xaA7a9CA87d3694B5755f213B5D04094b8d0F0A6F",
    symbol: "TRAC",
  },
  {
    address: "0xb23d80f5FefcDDaa212212F028021B41DEd428CF",
    symbol: "PRIME",
  },
  {
    address: "0x4E15361FD6b4BB609Fa63C81A2be19d873717870",
    symbol: "FTM",
  },
  {
    address: "0xA797A0b99b887eba09552334D4D58d7246220c30",
    symbol: "Geno ",
  },
  {
    address: "0xBa25B2281214300E4e649feAd9A6d6acD25f1c0a",
    symbol: "TREE",
  },
  {
    address: "0x2282c726F54c93193E6b8E5BF1B82303DC11D36e",
    symbol: "DAY",
  },
  {
    address: "0xF57e7e7C23978C3cAEC3C3548E3D615c346e79fF",
    symbol: "IMX",
  },
  {
    address: "0x4e3FBD56CD56c3e72c1403e103b45Db9da5B9D2B",
    symbol: "CVX",
  },
  {
    address: "0xb9f599ce614Feb2e1BBe58F180F370D05b39344E",
    symbol: "PORK",
  },
  {
    address: "0x4d224452801ACEd8B2F0aebE155379bb5D594381",
    symbol: "APE",
  },
  {
    address: "0x92D5942f468447f1F21c2092580F15544923b434",
    symbol: "VSTR",
  },
  {
    address: "0xD33526068D116cE69F19A9ee46F0bd304F21A51f",
    symbol: "RPL",
  },
  {
    address: "0x9E32b13ce7f2E80A01932B42553652E053D6ed8e",
    symbol: "Metis",
  },
  {
    address: "0x7420B4b9a0110cdC71fB720908340C03F9Bc03EC",
    symbol: "JASMY",
  },
  {
    address: "0xC96dE26018A54D51c097160568752c4E3BD6C364",
    symbol: "FBTC",
  },
  {
    address: "0x340D2bdE5Eb28c1eed91B2f790723E3B160613B7",
    symbol: "VEE",
  },
  {
    address: "0x8762db106B2c2A0bccB3A80d1Ed41273552616E8",
    symbol: "RSR",
  },
  {
    address: "0xBAcaCD83b68C92Ae07eF382d0c0277D1Bd1c7C4D",
    symbol: "PSALE",
  },
  {
    address: "0x467Bccd9d29f223BcE8043b84E8C8B282827790F",
    symbol: "TEL",
  },
  {
    address: "0x4D0528598F916Fd1D8dc80e5f54a8fEEDcFd4b18",
    symbol: "ATOS",
  },
  {
    address: "0x66761Fa41377003622aEE3c7675Fc7b5c1C2FaC5",
    symbol: "CPOOL",
  },
  {
    address: "0x8207c1FfC5B6804F6024322CcF34F29c3541Ae26",
    symbol: "OGN",
  },
  {
    address: "0xf1B99e3E573A1a9C5E6B2Ce818b617F0E664E86B",
    symbol: "oSQTH",
  },
  {
    address: "0xd9Fcd98c322942075A5C3860693e9f4f03AAE07b",
    symbol: "EUL",
  },
  {
    address: "0x9Ce84F6A69986a83d92C324df10bC8E64771030f",
    symbol: "CHEX",
  },
  {
    address: "0x8c1BEd5b9a0928467c9B1341Da1D7BD5e10b6549",
    symbol: "LsETH",
  },
  {
    address: "0x5aFE3855358E112B5647B952709E6165e1c1eEEe",
    symbol: "SAFE",
  },
  {
    address: "0xD101dCC414F310268c37eEb4cD376CcFA507F571",
    symbol: "RSC",
  },
  {
    address: "0x88800092fF476844f74dC2FC427974BBee2794Ae",
    symbol: "WALLET",
  },
  {
    address: "0x5B7533812759B45C2B44C19e320ba2cD2681b542",
    symbol: "AGIX",
  },
  {
    address: "0x28d38dF637dB75533bD3F71426F3410a82041544",
    symbol: "PROMPT",
  },
  {
    address: "0xE72B141DF173b999AE7c1aDcbF60Cc9833Ce56a8",
    symbol: "ETH+",
  },
  {
    address: "0x856c4Efb76C1D1AE02e20CEB03A2A6a08b0b8dC3",
    symbol: "OETH",
  },
  {
    address: "0x7DD9c5Cba05E151C895FDe1CF355C9A1D5DA6429",
    symbol: "GLM",
  },
  {
    address: "0xc4A11aaf6ea915Ed7Ac194161d2fC9384F15bff2",
    symbol: "WTON",
  },
  {
    address: "0x33349B282065b0284d756F0577FB39c158F935e6",
    symbol: "MPL",
  },
  {
    address: "0x595832F8FC6BF59c85C527fEC3740A1b7a361269",
    symbol: "POWR",
  },
  {
    address: "0xC08e7E23C235073C6807C2EFE7021304cb7c2815",
    symbol: "XUSD",
  },
  {
    address: "0x2b591e99afE9f32eAA6214f7B7629768c40Eeb39",
    symbol: "HEX",
  },
  {
    address: "0x40D16FC0246aD3160Ccc09B8D0D3A2cD28aE6C2f",
    symbol: "GHO",
  },
  {
    address: "0x6810e776880C02933D47DB1b9fc05908e5386b96",
    symbol: "GNO",
  },
  {
    address: "0xFe0c30065B384F05761f15d0CC899D4F9F9Cc0eB",
    symbol: "ETHFI",
  },
  {
    address: "0x0B498ff89709d3838a063f1dFA463091F9801c2b",
    symbol: "BTC2x-FLI",
  },
  {
    address: "0x744d70FDBE2Ba4CF95131626614a1763DF805B9E",
    symbol: "SNT",
  },
  {
    address: "0x51BA4550Ddb005F6aB1A579F7A78769895540B21",
    symbol: "PASA",
  },
  {
    address: "0xc7283b66Eb1EB5FB86327f08e1B5816b0720212B",
    symbol: "TRIBE",
  },
  {
    address: "0x6440f144b7e50D6a8439336510312d2F54beB01D",
    symbol: "BOLD",
  },
  {
    address: "0x32353A6C91143bfd6C7d363B546e62a9A2489A20",
    symbol: "AGLD",
  },
  {
    address: "0x81f8f0bb1cB2A06649E51913A151F0E7Ef6FA321",
    symbol: "VITA",
  },
  {
    address: "0x383518188C0C6d7730D91b2c03a03C837814a899",
    symbol: "OHM",
  },
  {
    address: "0x1a7e4e63778B4f12a199C062f3eFdD288afCBce8",
    symbol: "agEUR",
  },
  {
    address: "0x9C7BEBa8F6eF6643aBd725e45a4E8387eF260649",
    symbol: "G",
  },
  {
    address: "0xCaB84bc21F9092167fCFe0ea60f5CE053ab39a1E",
    symbol: "Block",
  },
  {
    address: "0xd1d2Eb1B1e90B638588728b4130137D262C87cae",
    symbol: "GALA",
  },
  {
    address: "0xAC57De9C1A09FeC648E93EB98875B212DB0d460B",
    symbol: "BabyDoge",
  },
  {
    address: "0x0D8775F648430679A709E98d2b0Cb6250d2887EF",
    symbol: "BAT",
  },
  {
    address: "0x36f9975d8184a65be42290D5A8764Dc97f3D9396",
    symbol: "BTCM",
  },
  {
    address: "0x6123B0049F904d730dB3C36a31167D9d4121fA6B",
    symbol: "RBN",
  },
  {
    address: "0x1151CB3d861920e07a38e03eEAd12C32178567F6",
    symbol: "Bonk",
  },
  {
    address: "0xfd418e42783382E86Ae91e445406600Ba144D162",
    symbol: "ZRC",
  },
  {
    address: "0xbe0Ed4138121EcFC5c0E56B40517da27E6c5226B",
    symbol: "ATH",
  },
  {
    address: "0x99D8a9C45b2ecA8864373A26D1459e3Dff1e17F3",
    symbol: "MIM",
  },
  {
    address: "0xf6718b2701D4a6498eF77D7c152b2137Ab28b8A3",
    symbol: "stBTC",
  },
  {
    address: "0x738865301A9b7Dd80Dc3666dD48cF034ec42bdDa",
    symbol: "AGRS",
  },
  {
    address: "0x1036c90a7DeA8A392901147870f74A40Af812bB4",
    symbol: "RUSD",
  },
  {
    address: "0xaDB2437e6F65682B85F814fBc12FeC0508A7B1D0",
    symbol: "UNCX",
  },
  {
    address: "0x320623b8E4fF03373931769A31Fc52A4E78B5d70",
    symbol: "RSR",
  },
  {
    address: "0xe28b3B32B6c345A34Ff64674606124Dd5Aceca30",
    symbol: "INJ",
  },
  {
    address: "0x4DC26fC5854e7648a064a4ABD590bBE71724C277",
    symbol: "ANIME",
  },
  {
    address: "0xC1f33e0cf7e40a67375007104B929E49a581bafE",
    symbol: "SPOT",
  },
  {
    address: "0xdB792B1D8869A7CFc34916d6c845Ff05A7C9b789",
    symbol: "ccBCH",
  },
  {
    address: "0xa91D704B6edA6e207413bB888bd1B00e3037Dd24",
    symbol: "QQQAI",
  },
  {
    address: "0xc944E90C64B2c07662A292be6244BDf05Cda44a7",
    symbol: "GRT",
  },
  {
    address: "0x35e78b3982E87ecfD5b3f3265B601c046cDBe232",
    symbol: "XAI",
  },
  {
    address: "0xE41d2489571d322189246DaFA5ebDe1F4699F498",
    symbol: "ZRX",
  },
  {
    address: "0xdD468A1DDc392dcdbEf6db6e34E89AA338F9F186",
    symbol: "MUSD",
  },
  {
    address: "0x3Ba925fdeAe6B46d0BB4d424D829982Cb2F7309e",
    symbol: "RBX",
  },
  {
    address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
    symbol: "USDS",
  },
  {
    address: "0xD7EFB00d12C2c13131FD319336Fdf952525dA2af",
    symbol: "XPR",
  },
  {
    address: "0x9F9c8ec3534c3cE16F928381372BfbFBFb9F4D24",
    symbol: "GLQ",
  },
  {
    address: "0x2BE056e595110B30ddd5eaF674BdAC54615307d9",
    symbol: "APUFF",
  },
  {
    address: "0x77FbA179C79De5B7653F68b5039Af940AdA60ce0",
    symbol: "FORTH",
  },
  {
    address: "0x04C17b9D3b29A78F7Bd062a57CF44FC633e71f85",
    symbol: "IMPT",
  },
  {
    address: "0x9Ce115f0341ae5daBC8B477b74E83db2018A6f42",
    symbol: "HAIR",
  },
  {
    address: "0x9619b0eaDD70d643Cb2BBE6d5752B15C16fbf2d2",
    symbol: "BITCOIN2",
  },
  {
    address: "0x4EC1b60B96193a64AcAe44778e51f7BfF2007831",
    symbol: "EDGE",
  },
  {
    address: "0x5DE8ab7E27f6E7A1fFf3E5B337584Aa43961BEeF",
    symbol: "SDEX",
  },
  {
    address: "0xe0B7AD7F8F26e2b00C8b47b5Df370f15F90fCF48",
    symbol: "SOLX",
  },
  {
    address: "0x55296f69f40Ea6d20E478533C15A6B08B654E758",
    symbol: "XYO",
  },
  {
    address: "0xc20059e0317DE91738d13af027DfC4a50781b066",
    symbol: "SPK",
  },
  {
    address: "0x243cACb4D5fF6814AD668C3e225246efA886AD5a",
    symbol: "SHI",
  },
  {
    address: "0x1495bc9e44Af1F8BCB62278D2bEC4540cF0C05ea",
    symbol: "DEAI",
  },
  {
    address: "0xA882606494D86804B5514E07e6Bd2D6a6eE6d68A",
    symbol: "WPLS",
  },
  {
    address: "0x21BfBDa47A0B4B5b1248c767Ee49F7caA9B23697",
    symbol: "OVR",
  },
  {
    address: "0xcAb254f1a32343f11aB41fbdE90eCB410cDe348a",
    symbol: "FROGE",
  },
  {
    address: "0xcb1592591996765Ec0eFc1f92599A19767ee5ffA",
    symbol: "BIO",
  },
  {
    address: "0x32Ab7F30BA2152106FEE3D855aE318F2B4c4e65F",
    symbol: "EBEAR",
  },
  {
    address: "0x35D8949372D46B7a3D5A56006AE77B215fc69bC0",
    symbol: "USD0++",
  },
  {
    address: "0x3432B6A60D23Ca0dFCa7761B7ab56459D9C964D0",
    symbol: "FXS",
  },
  {
    address: "0xB8c77482e45F1F44dE1745F52C74426C631bDD52",
    symbol: "BNB",
  },
  {
    address: "0x30aE41D5f9988D359c733232C6c693c0e645C77E",
    symbol: "WAAC",
  },
  {
    address: "0x39D5313C3750140E5042887413bA8AA6145a9bd2",
    symbol: "EMP",
  },
  {
    address: "0x0B7f0e51Cd1739D6C96982D55aD8fA634dd43A9C",
    symbol: "DMT",
  },
  {
    address: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
    symbol: "PYUSD",
  },
  {
    address: "0x0bc529c00C6401aEF6D220BE8C6Ea1667F6Ad93e",
    symbol: "YFI",
  },
  {
    address: "0x24fcFC492C1393274B6bcd568ac9e225BEc93584",
    symbol: "MAVIA",
  },
  {
    address: "0x4C1746A800D224393fE2470C70A35717eD4eA5F1",
    symbol: "PLUME",
  },
  {
    address: "0xAa9806c938836627Ed1a41Ae871c7E1889AE02Ca",
    symbol: "EDGEN",
  },
  {
    address: "0xCb76314C2540199f4B844D4ebbC7998C604880cA",
    symbol: "BERRY",
  },
  {
    address: "0xccB365D2e11aE4D6d74715c680f56cf58bF4bF10",
    symbol: "WEPE",
  },
  {
    address: "0x97Ad75064b20fb2B2447feD4fa953bF7F007a706",
    symbol: "beraSTONE",
  },
  {
    address: "0x8248270620Aa532E4d64316017bE5E873E37cc09",
    symbol: "DEVVE",
  },
  {
    address: "0x0B010000b7624eb9B3DfBC279673C76E9D29D5F7",
    symbol: "OBOL",
  },
  {
    address: "0x7C5A0CE9267ED19B22F8cae653F198e3E8daf098",
    symbol: "SAN",
  },
  {
    address: "0x3845badAde8e6dFF049820680d1F14bD3903a5d0",
    symbol: "SAND",
  },
  {
    address: "0x1776e1F26f98b1A5dF9cD347953a26dd3Cb46671",
    symbol: "NMR",
  },
  {
    address: "0xE89751b31CD4E2EB7006Ce168857F72c8e37bCeB",
    symbol: "MATH",
  },
  {
    address: "0x85F17Cf997934a597031b2E18a9aB6ebD4B9f6a4",
    symbol: "NEAR",
  },
  {
    address: "0x0F81001eF0A83ecCE5ccebf63EB302c70a39a654",
    symbol: "DOLO",
  },
  {
    address: "0x9abC68B33961268A3Ea4116214d7039226de01E1",
    symbol: "USDC",
  },
  {
    address: "0x6731c740494b1c77D9B1598eB6f8FC317Ede0C15",
    symbol: "BGB",
  },
  {
    address: "0x74950FC112473caba58193c6bF6412a6f1e4d7d2",
    symbol: "wVTRS",
  },
  {
    address: "0x5eed99d066a8CaF10f3E4327c1b3D8b673485eED",
    symbol: "SEED",
  },
  {
    address: "0xf951E335afb289353dc249e82926178EaC7DEd78",
    symbol: "swETH",
  },
  {
    address: "0x3af33bEF05C2dCb3C7288b77fe1C8d2AeBA4d789",
    symbol: "KROM",
  },
  {
    address: "0x614577036F0a024DBC1C88BA616b394DD65d105a",
    symbol: "GNUS",
  },
  {
    address: "0xCC4304A31d09258b0029eA7FE63d032f52e44EFe",
    symbol: "SWAP",
  },
  {
    address: "0xB58E61C3098d85632Df34EecfB899A1Ed80921cB",
    symbol: "ZCHF",
  },
  {
    address: "0x49D72e3973900A195A155a46441F0C08179FdB64",
    symbol: "CRETH2",
  },
  {
    address: "0x94a8b4EE5CD64C79D0Ee816f467EA73009f51aA0",
    symbol: "RIO",
  },
  {
    address: "0x6fB3e0A217407EFFf7Ca062D46c26E5d60a14d69",
    symbol: "IOTX",
  },
  {
    address: "0xDd66781D0E9a08D4FBb5eC7BAc80B691BE27F21D",
    symbol: "AXGT",
  },
  {
    address: "0x9D65fF81a3c488d585bBfb0Bfe3c7707c7917f54",
    symbol: "SSV",
  },
  {
    address: "0x423f4e6138E475D85CF7Ea071AC92097Ed631eea",
    symbol: "PNDC",
  },
  {
    address: "0xF1A7000000950C7ad8Aff13118Bb7aB561A448ee",
    symbol: "FLAY",
  },
  {
    address: "0x19247618D79E3fc4d4866169789E4B8eEDef52E6",
    symbol: "CAI",
  },
  {
    address: "0xF5581dFeFD8Fb0e4aeC526bE659CFaB1f8c781dA",
    symbol: "HOPR",
  },
  {
    address: "0xDDF73eAcB2218377FC38679aD14dfce51B651Dd1",
    symbol: "USDx",
  },
  {
    address: "0x922D8563631B03C2c4cf817f4d18f6883AbA0109",
    symbol: "LOCK",
  },
  {
    address: "0xcb86c6A22CB56B6cf40CaFEDb06BA0DF188a416E",
    symbol: "SURE",
  },
  {
    address: "0xe04BeF11f54eFdF621D48c28c845Ad925D46F4B7",
    symbol: "VISTAPEPE",
  },
  {
    address: "0x427A03Fb96D9A94A6727fbcfbBA143444090dd64",
    symbol: "PIXL",
  },
  {
    address: "0xE6Bfd33F52d82Ccb5b37E16D3dD81f9FFDAbB195",
    symbol: "SXT",
  },
  {
    address: "0xC669928185DbCE49d2230CC9B0979BE6DC797957",
    symbol: "BTT",
  },
  {
    address: "0x056Fd409E1d7A124BD7017459dFEa2F387b6d5Cd",
    symbol: "GUSD",
  },
  {
    address: "0x44108f0223A3C3028F5Fe7AEC7f9bb2E66beF82F",
    symbol: "ACX",
  },
  {
    address: "0xFb782396c9b20E564A64896181c7AC8d8979d5F4",
    symbol: "DIVER",
  },
  {
    address: "0x289Ff00235D2b98b0145ff5D4435d3e92f9540a6",
    symbol: "BOOE",
  },
  {
    address: "0x382ea807A61a418479318Efd96F1EFbC5c1F2C21",
    symbol: "PEW",
  },
  {
    address: "0x226bb599a12C826476e3A771454697EA52E9E220",
    symbol: "PRO",
  },
  {
    address: "0x24D73Bca2bD9c3a61E99dFc7cB86D3C379EbDEd7",
    symbol: "MAI",
  },
  {
    address: "0xA95C5ebB86E0dE73B4fB8c47A45B792CFeA28C23",
    symbol: "SDL",
  },
  {
    address: "0x467719aD09025FcC6cF6F8311755809d45a5E5f3",
    symbol: "AXL",
  },
  {
    address: "0x468EAbcB5C914ac59e72691F8fc970880A94f4B3",
    symbol: "eMDR",
  },
  {
    address: "0x590F820444fA3638e022776752c5eEF34E2F89A6",
    symbol: "ALPH",
  },
  {
    address: "0xC5260f22A810646F767fCD61164D40f48F4491b9",
    symbol: "Erald",
  },
  {
    address: "0x712bd4Beb54C6B958267d9dB0259abdBb0BFF606",
    symbol: "UDS",
  },
  {
    address: "0xEDB171C18cE90B633DB442f2A6F72874093b49Ef",
    symbol: "WAMPL",
  },
  {
    address: "0x9813037ee2218799597d83D4a5B6F3b6778218d9",
    symbol: "BONE",
  },
  {
    address: "0x8Fe815417913a93Ea99049FC0718ee1647A2a07c",
    symbol: "XSWAP",
  },
  {
    address: "0x5283D291DBCF85356A21bA090E6db59121208b44",
    symbol: "BLUR",
  },
  {
    address: "0x9F52c8ecbEe10e00D9faaAc5Ee9Ba0fF6550F511",
    symbol: "SIPHER",
  },
  {
    address: "0xc6C9448a86882D73164A984FA52285Ab51c823bC",
    symbol: "RPILL",
  },
  {
    address: "0x00c83aeCC790e8a4453e5dD3B0B4b3680501a7A7",
    symbol: "SKL",
  },
  {
    address: "0x464db6547454aC8F9Cb608a41f03661378Ac6edA",
    symbol: "GODWILLING",
  },
  {
    address: "0xCa14007Eff0dB1f8135f4C25B34De49AB0d42766",
    symbol: "STRK",
  },
  {
    address: "0x6985884C4392D348587B19cb9eAAf157F13271cd",
    symbol: "ZRO",
  },
  {
    address: "0x826180541412D574cf1336d22c0C0a287822678A",
    symbol: "FLIP",
  },
  {
    address: "0xc56C7A0eAA804f854B536A5F3D5f49D2EC4B12b8",
    symbol: "GME",
  },
  {
    address: "0xB4b9DC1C77bdbb135eA907fd5a08094d98883A35",
    symbol: "SWEAT",
  },
  {
    address: "0xc221b7E65FfC80DE234bbB6667aBDd46593D34F0",
    symbol: "wCFG",
  },
  {
    address: "0x8CCD897ca6160ED76755383B201C1948394328c7",
    symbol: "wBAI",
  },
  {
    address: "0x93eEB426782BD88fCD4B48D7b0368CF061044928",
    symbol: "TRG",
  },
  {
    address: "0xB50721BCf8d664c30412Cfbc6cf7a15145234ad1",
    symbol: "ARB",
  },
  {
    address: "0x8C282C35B5E1088bb208991c151182A782637699",
    symbol: "MONAI",
  },
  {
    address: "0x5f98805A4E8be255a32880FDeC7F6728C6568bA0",
    symbol: "LUSD",
  },
  {
    address: "0x66DB09B90104A046F8525af9773b5567363f1485",
    symbol: "DONALD",
  },
  {
    address: "0xa2E2a4ecd9f909262CC8628E8Db90f8F5802be81",
    symbol: "DogeX",
  },
  {
    address: "0xC4441c2BE5d8fA8126822B9929CA0b81Ea0DE38E",
    symbol: "USUAL",
  },
  {
    address: "0x89A8c847f41C0dfA6c8B88638bACca8a0b777Da7",
    symbol: "ELX",
  },
  {
    address: "0x1E5193ccC53f25638Aa22a940af899B692e10B09",
    symbol: "ALLUO",
  },
  {
    address: "0x4da27a545c0c5B758a6BA100e3a049001de870f5",
    symbol: "stkAAVE",
  },
  {
    address: "0xAAA9214F675316182Eaa21C85f0Ca99160CC3AAA",
    symbol: "QANX",
  },
  {
    address: "0xB4EFd85c19999D84251304bDA99E90B92300Bd93",
    symbol: "RPL",
  },
  {
    address: "0xEd04915c23f00A313a544955524EB7DBD823143d",
    symbol: "ACH",
  },
  {
    address: "0x772358ef6ed3e18BdE1263F7d229601c5fa81875",
    symbol: "SNPAD",
  },
  {
    address: "0xCdF7028ceAB81fA0C6971208e83fa7872994beE5",
    symbol: "T",
  },
  {
    address: "0x1494CA1F11D487c2bBe4543E90080AeBa4BA3C2b",
    symbol: "DPI",
  },
  {
    address: "0xB1F1ee126e9c96231Cc3d3fAD7C08b4cf873b1f1",
    symbol: "BIFI",
  },
  {
    address: "0xDFDb7f72c1F195C5951a234e8DB9806EB0635346",
    symbol: "NFD",
  },
  {
    address: "0x4951beC6F4DFc23935C0Ec8Af92f231F4C20ea03",
    symbol: "BTM",
  },
  {
    address: "0xdab396cCF3d84Cf2D07C4454e10C8A6F5b008D2b",
    symbol: "GFI",
  },
  {
    address: "0x17EF75AA22dD5f6C2763b8304Ab24f40eE54D48a",
    symbol: "RVP",
  },
  {
    address: "0x967da4048cD07aB37855c090aAF366e4ce1b9F48",
    symbol: "OCEAN",
  },
  {
    address: "0x508E00D5ceF397B02d260D035e5EE80775e4C821",
    symbol: "1CAT",
  },
  {
    address: "0x6BF765C43030387a983f429c1438e9D2025B7E12",
    symbol: "PEPES",
  },
  {
    address: "0x0F5D2fB29fb7d3CFeE444a200298f468908cC942",
    symbol: "MANA",
  },
  {
    address: "0xcDbddbdEFB0eE3eF03a89AFcd714aa4ef310D567",
    symbol: "VERTAI",
  },
  {
    address: "0x9E976F211daea0D652912AB99b0Dc21a7fD728e4",
    symbol: "MAP",
  },
  {
    address: "0x4d1C297d39C5c1277964D0E3f8Aa901493664530",
    symbol: "PUFFER",
  },
  {
    address: "0x7CdBfC86A0BFa20F133748B0CF5cEa5b787b182c",
    symbol: "TKST",
  },
  {
    address: "0x9BE89D2a4cd102D8Fecc6BF9dA793be995C22541",
    symbol: "BBTC",
  },
  {
    address: "0x814A870726EdB7Dfc4798300ae1ce3E5Da0Ac467",
    symbol: "daCat",
  },
  {
    address: "0x05BE1d4c307C19450A6Fd7cE7307cE72a3829A60",
    symbol: "IMF",
  },
  {
    address: "0xEc1766AAC9de1d8e3F70F69f698A163A717D910c",
    symbol: "DNB",
  },
  {
    address: "0x4268a135840e5273E9DcB3Dc78303767D3964f43",
    symbol: "NFT",
  },
  {
    address: "0x0954906da0Bf32d5479e25f46056d22f08464cab",
    symbol: "INDEX",
  },
  {
    address: "0x7F75AA2274273F4d41267A0E2Cd6c9b96C5B7510",
    symbol: "POP",
  },
  {
    address: "0x857FfC55B1Aa61A7fF847C82072790cAE73cd883",
    symbol: "EEFI",
  },
  {
    address: "0x594DaaD7D77592a2b97b725A7AD59D7E188b5bFa",
    symbol: "APU",
  },
  {
    address: "0x0FD10b9899882a6f2fcb5c371E17e70FdEe00C38",
    symbol: "PUNDIX",
  },
  {
    address: "0x38e382F74dfb84608F3C1F10187f6bEf5951DE93",
    symbol: "MUBI",
  },
  {
    address: "0x00f3C42833C3170159af4E92dbb451Fb3F708917",
    symbol: "ICP",
  },
  {
    address: "0xc3f822e94c321dD3Ee53ca46B78098ea79b7ec8d",
    symbol: "BTCBULL",
  },
  {
    address: "0x06450dEe7FD2Fb8E39061434BAbCFC05599a6Fb8",
    symbol: "XEN",
  },
  {
    address: "0xf94e7d0710709388bCe3161C32B4eEA56d3f91CC",
    symbol: "DSync",
  },
  {
    address: "0x15D4c048F83bd7e37d49eA4C83a07267Ec4203dA",
    symbol: "GALA",
  },
  {
    address: "0x5026F006B85729a8b14553FAE6af249aD16c9aaB",
    symbol: "WOJAK",
  },
  {
    address: "0x940a2dB1B7008B6C776d4faaCa729d6d4A4AA551",
    symbol: "DUSK",
  },
  {
    address: "0x82a605D6D9114F4Ad6D5Ee461027477EeED31E34",
    symbol: "SNSY",
  },
  {
    address: "0x23B608675a2B2fB1890d3ABBd85c5775c51691d5",
    symbol: "SOCKS",
  },
  {
    address: "0x15e6E0D4ebeAC120F9a97e71FaA6a0235b85ED12",
    symbol: "SAVM",
  },
  {
    address: "0x6B4c7A5e3f0B99FCD83e9c089BDDD6c7FCe5c611",
    symbol: "MM",
  },
  {
    address: "0xA36FDBBAE3c9d55a1d67EE5821d53B50B63A1aB9",
    symbol: "TEMP",
  },
  {
    address: "0xDB5C3C46E28B53a39C255AA39A411dD64e5fed9c",
    symbol: "NCR",
  },
  {
    address: "0x186eF81fd8E77EEC8BfFC3039e7eC41D5FC0b457",
    symbol: "INSP",
  },
  {
    address: "0x323c03c48660fE31186fa82c289b0766d331Ce21",
    symbol: "OPEN",
  },
  {
    address: "0xA89060952228C8D2A0019A0B949e90E2Fe0a70Ef",
    symbol: "WOOF",
  },
  {
    address: "0xe9572938bcbf08adceE86Fd12A7C0D08dC4Ab841",
    symbol: "INS",
  },
  {
    address: "0xB98d4C97425d9908E66E53A6fDf673ACcA0BE986",
    symbol: "ABT",
  },
  {
    address: "0xa47c8bf37f92aBed4A126BDA807A7b7498661acD",
    symbol: "UST",
  },
  {
    address: "0x62D0A8458eD7719FDAF978fe5929C6D342B0bFcE",
    symbol: "BEAM",
  },
  {
    address: "0x40a7dF3dF8b56147B781353D379cB960120211D7",
    symbol: "MOBY",
  },
  {
    address: "0xa84f95eb3DaBdc1bbD613709ef5F2fD42CE5bE8d",
    symbol: "EAI",
  },
  {
    address: "0xDe30da39c46104798bB5aA3fe8B9e0e1F348163F",
    symbol: "GTC",
  },
  {
    address: "0xf3b9569F82B18aEf890De263B84189bd33EBe452",
    symbol: "CAW",
  },
  {
    address: "0x30D20208d987713f46DFD34EF128Bb16C404D10f",
    symbol: "SD",
  },
  {
    address: "0x9d409a0A012CFbA9B15F6D4B36Ac57A46966Ab9a",
    symbol: "yvBOOST",
  },
  {
    address: "0x8292Bb45bf1Ee4d140127049757C2E0fF06317eD",
    symbol: "RLUSD",
  },
  {
    address: "0xE2AD0BF751834f2fbdC62A41014f84d67cA1de2A",
    symbol: "ERA",
  },
  {
    address: "0xae7ab96520DE3A18E5e111B5EaAb095312D7fE84",
    symbol: "stETH",
  },
  {
    address: "0x3A856d4effa670C54585a5D523e96513e148e95d",
    symbol: "TRIAS",
  },
  {
    address: "0xABe580E7ee158dA464b51ee1a83Ac0289622e6be",
    symbol: "XFT",
  },
  {
    address: "0x25722Cd432d02895d9BE45f5dEB60fc479c8781E",
    symbol: "SPONGE",
  },
  {
    address: "0x6c6EE5e31d828De241282B9606C8e98Ea48526E2",
    symbol: "HOT",
  },
  {
    address: "0x20d4DB1946859E2Adb0e5ACC2eac58047aD41395",
    symbol: "MOONEY",
  },
  {
    address: "0x2dfF88A56767223A5529eA5960Da7A3F5f766406",
    symbol: "ID",
  },
  {
    address: "0x3b3F95938958A4029Fa8b01873e2721b02950883",
    symbol: "CSWAP",
  },
  {
    address: "0x28561B8A2360F463011c16b6Cc0B0cbEF8dbBcad",
    symbol: "MOODENG",
  },
  {
    address: "0xB17548c7B510427baAc4e267BEa62e800b247173",
    symbol: "SMT",
  },
  {
    address: "0x44971ABF0251958492FeE97dA3e5C5adA88B9185",
    symbol: "basedAI",
  },
  {
    address: "0x6E2a43be0B1d33b726f0CA3b8de60b3482b8b050",
    symbol: "ARKM",
  },
  {
    address: "0xe53EC727dbDEB9E2d5456c3be40cFF031AB40A55",
    symbol: "SUPER",
  },
  {
    address: "0x76e222b07C53D28b89b0bAc18602810Fc22B49A8",
    symbol: "JOE",
  },
  {
    address: "0x58b6A8A3302369DAEc383334672404Ee733aB239",
    symbol: "LPT",
  },
  {
    address: "0x6BC08509B36A98E829dFfAD49Fde5e412645d0a3",
    symbol: "WOOF",
  },
  {
    address: "0x8400D94A5cb0fa0D041a3788e395285d61c9ee5e",
    symbol: "UBT",
  },
  {
    address: "0xC0d4Ceb216B3BA9C3701B291766fDCbA977ceC3A",
    symbol: "BTRFLY",
  },
  {
    address: "0x3506424F91fD33084466F402d5D97f05F8e3b4AF",
    symbol: "CHZ",
  },
  {
    address: "0x37fE0f067FA808fFBDd12891C0858532CFE7361d",
    symbol: "CIV",
  },
  {
    address: "0x7613C48E0cd50E42dD9Bf0f6c235063145f6f8DC",
    symbol: "PIRATE",
  },
  {
    address: "0x1121AcC14c63f3C872BFcA497d10926A6098AAc5",
    symbol: "DOGE",
  },
  {
    address: "0xD13c7342e1ef687C5ad21b27c2b65D772cAb5C8c",
    symbol: "UOS",
  },
  {
    address: "0xBB0E17EF65F82Ab018d8EDd776e8DD940327B28b",
    symbol: "AXS",
  },
  {
    address: "0xc2544A32872A91F4A553b404C6950e89De901fdb",
    symbol: "FPIS",
  },
  {
    address: "0xEeee2A2E650697d2A8e8BC990C2f3d04203bE06f",
    symbol: "FP",
  },
  {
    address: "0x491604c0FDF08347Dd1fa4Ee062a822A5DD06B5D",
    symbol: "CTSI",
  },
  {
    address: "0xA35b1B31Ce002FBF2058D22F30f95D405200A15b",
    symbol: "ETHx",
  },
  {
    address: "0xA1290d69c65A6Fe4DF752f95823fae25cB99e5A7",
    symbol: "rsETH",
  },
  {
    address: "0xcAFeAA466736ac01e0AC9Ca72644beF348694731",
    symbol: "RWIV",
  },
] as const
